import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  InputLabel,
  makeStyles,
  Menu,
  MenuItem,
  Select,
  TextField,
  Typography
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import RemoveIcon from "@material-ui/icons/Remove";
import { withStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import { UploadButton } from "components/request-document/components/Commons";
import { format } from "date-fns";
import { useFormik } from "formik";
import {
  boiDepartmentId,
  RequestDocStatus,
  RoleId,
  STATUS_PROCESS,
  VISA_TYPE_ID,
  VISA_TYPE_NAME
} from "libs/configs/constant";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import useModalLoading from "libs/hooks/useModalLoading";
import { getErrorMessage, isError, sortByName } from "libs/utils/form";
import HttpClient from "libs/utils/HttpClient";
import { get } from "lodash";
import mime from "mime";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import {
  approveDoc, boiapproveex,
  boiRecieved, CheckpropertiesLog, clearConsults,
  completeDoc,
  consultDoc, Departmentupload, docLogs,
  forceApprove,
  healthinsuranceApprove,
  otherApproveDoc,
  otherUndo,
  ReasonOtherdep,
  reassignDoc,
  rejectDoc,
  requestDocuments,
  returndraft,
  superaccessList,
  superaccessremove,
  undoDoc
} from "redux/modules/allDocumentsSlice";
import { selectIsBOI, selectIsOtherDepartment } from "redux/modules/authSlice";
import { getPrintList } from "redux/modules/departmentSlice";
import { getEmployeeList } from "redux/modules/employeeSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { getDocumentrequiredbydraftid } from "redux/modules/visaForm";
import AllDocumentsService from "services/AllDocumentsService";
import ConfigSmartServiceService from "services/ConfigSmartServiceService";
import FileService from "services/FileService";
import ReportService from "services/ReportService";
import * as yup from "yup";

const useStyles = makeStyles((theme) => ({
  buttonInfo: {
    width: "100px",
    height: "40px",
    marginLeft: "15px",
    fontSize: "12px",
  },
  buttonStatusDetail: {
    backgroundColor: "white",
    padding: 5,
    borderRadius: "50%",
    boxShadow: "0px 0px 2px 2px rgba(23, 43, 77, 0.2)",
    marginLeft: "15px",
    cursor: "pointer",
  },
  warpDialog: {
    padding: "30px",
    minWidth: "600px",
    minHeight: "200px",
  },
  dtitle: {
    color: "#40B8D4",
  },
  warpRowDialog: {
    marginTop: 10,
  },
  warpFormControl: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  d2title: {
    color: "#172B4D",
    paddingBottom: 10,
  },
  textDialog: {
    width: "100%",
  },
  warpButtonDialogSave: {
    display: "flex",
  },
  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
  rowMenuPopOver: {
    padding: 15,
    paddingTop: 0,
  },
  rowPopTitle: {
    paddingBottom: "15px",
    borderBottom: "1px solid lightgray",
    fontWeight: "500",
    color: "#101A5F",
    textAlign: "center",
    marginBottom: 15,
  },
  rowPopItem: {
    padding: 5,
    fontWeight: "500",
    color: "#101A5F",
    display: "flex",
    justifyContent: "flex-start",
  },
  iconPop: {
    color: "white",
    fontWeight: "bold",
    marginRight: "10px",
    borderRadius: "50%",
    verticalAlign: "middle",
    width: "25px",
    height: "25px",
  },
  wrapField: {
    marginTop: 15,
  },
  formControl: {
    width: "100%",
  },
  wrapRequestDoc: {
    marginBottom: 10,
  },
  textField: {
    width: "100%",
  },
  wrapRequestDocPending: {
    fontSize: "16px",
    color: "#feb969",
  },
  superremove: {
    color: "orangered",
    cursor: "pointer",
  },
  superwrapSupervisorList: {
    display: "flex",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    padding: "10px 5px",
    justifyContent: "space-between",
  },
}));

export default function AdminButtonController({
  hideSaveDraft = false,
  isDisabledNextButton = false,
  isExtend = false,
  nextButtonText = "Next",
  onClickSaveDraft = () => { },
  onClickNext = () => { },
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { showLoading, hideLoading } = useModalLoading();
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();

  const { role } = useSelector((state) => state.auth);
  const _Role = useSelector((e) => {
    return e.user.profile.roleId;
  });
  const {
    draftId: draftIdSelected,
    staffID,
    statusProcessId,
    statusDocId,
  } = useSelector((state) => state.allDocuments?.detail);

  const { consults, detail: docDetail } = useSelector(
    (state) => state.allDocuments
  );

  const { profile } = useSelector((state) => state.user);
  const [open, setOpen] = React.useState(false);
  const [openSupervisor, setOpenSupervisor] = React.useState(false);
  const [openDepApprove, setOpenDepApprove] = React.useState(false);
  const [openDepAssign, setOpenDepAssign] = React.useState(false);
  const [openReqLogs, setOpenReqLogs] = React.useState(false);
  const [openReqDocs, setOpenReqDocs] = React.useState(false);
  const [openReason, setOpenReason] = React.useState(false);
  const [ReasonStatus, setReasonStatus] = React.useState("");
  const [empRoleSelected, setEmpRoleSelected] = React.useState([]);
  const [PrintFileData, setPrintFileData] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openReturnRemark, setOpenReturnRemark] = React.useState(false);

  const [anchorElPrint, setAnchorElPrint] = React.useState(null);
  const openPrint = Boolean(anchorElPrint);
  const handleClickPrint = (event) => {
    setAnchorElPrint(event.currentTarget);
  };
  const handleClosePrint = () => {
    setAnchorElPrint(null);
  };

  const isBOI = useSelector(selectIsBOI);
  const isOther = useSelector(selectIsOtherDepartment);
  const { configApprveSmartFrom } = useSelector(
    (state) => state.allDocuments.detail
  );

  useEffect(async () => {
    const body = {
      departmentId: profile.departmentId,
    };

    await dispatch(getEmployeeList(body));
  }, []);

  useEffect(async () => {
    if (draftIdSelected) {
      const bodyC = {
        draftId: draftIdSelected,
      };
      await dispatch(superaccessList(bodyC));
      await dispatch(
        getDocumentrequiredbydraftid({ draftId: draftIdSelected })
      );
      const bodyPrint = {
        draftId: draftIdSelected,
        departmentId: profile.departmentId,
      };
      const responstPrint = await dispatch(getPrintList(bodyPrint));

      setPrintFileData(responstPrint?.payload);
    }
  }, [draftIdSelected]);

  const boiApproveDoc = async () => {
    if (
      docDetail?.smartserviceId === VISA_TYPE_ID.StatusReport ||
      docDetail?.smartserviceId === VISA_TYPE_ID.Termination
    ) {
      const msg = VISA_TYPE_NAME[docDetail?.smartserviceId];
      if (!window.confirm(`Do you want to approve ${msg}?`)) return;

      showAdminLoading();
      const body = {
        draftId: draftIdSelected,
      };

      await dispatch(boiapproveex(body));
      hideAdminLoading();
    } else {
      setOpenDepAssign(true);
    }
  };

  const boiRecievedDoc = async () => {
    if (!window.confirm("Do you want to Recieved?")) {
      return;
    }
    showAdminLoading();
    const body = {
      draftId: draftIdSelected,
      Remark: "",
    };

    await dispatch(boiRecieved(body));
    hideAdminLoading();
  };

  const documentPrint = async () => {
    const body = {
      draftId: draftIdSelected,
      Remark: "",
    };

    await dispatch(boiRecieved(body));
  };

  const returnToDraft = async (draftRemark) => {
    if (!window.confirm("Do you want to send back to user?")) {
      return;
    }
    showAdminLoading();
    const body = {
      draftId: draftIdSelected,
      draftRemark,
    };

    await dispatch(returndraft(body));
    hideAdminLoading();
  };

  const reviewHealthInsurance = async (isApprove) => {
    if (!window.confirm("Do you want to approve health insurance?")) {
      return;
    }
    showAdminLoading();
    const body = {
      draftId: draftIdSelected,
    };

    await dispatch(healthinsuranceApprove(body));
    hideAdminLoading();
  };

  const forceDocStatus = async (isApprove) => {
    const message = isApprove ? "approve" : "reject";

    if (!window.confirm(`Do you want to ${message}?`)) {
      return;
    }
    showAdminLoading();
    const body = {
      draftId: draftIdSelected,
      isApprove: isApprove,
    };

    await dispatch(forceApprove(body));
    hideAdminLoading();
  };

  const otherApprove = async () => {
    if (!window.confirm("Do you want to approve?")) {
      return;
    }
    // showAdminLoading();
    // const body = {
    //   draftId: draftIdSelected,
    // };

    // await dispatch(otherApproveDoc(body));
    // hideAdminLoading();
    setReasonStatus("1");
    setOpenReason(true);
  };

  const boiUndoDoc = async () => {
    if (!window.confirm("Do you want to undo?")) {
      return;
    }
    showAdminLoading();
    const body = {
      draftId: draftIdSelected,
    };

    await dispatch(undoDoc(body));
    const bodyPrint = {
      draftId: draftIdSelected,
      departmentId: profile.departmentId,
    };

    const responstPrint = await dispatch(getPrintList(bodyPrint));
    setPrintFileData(responstPrint?.payload);
    hideAdminLoading();
  };

  const otherUndoDoc = async () => {
    if (!window.confirm("Do you want to undo?")) {
      return;
    }
    showAdminLoading();
    const body = {
      draftId: draftIdSelected,
    };

    await dispatch(otherUndo(body));
    const bodyPrint = {
      draftId: draftIdSelected,
      departmentId: profile.departmentId,
    };

    const responstPrint = await dispatch(getPrintList(bodyPrint));
    setPrintFileData(responstPrint?.payload);
    hideAdminLoading();
  };

  const rejectDocument = async () => {
    if (!window.confirm("Do you want to reject?")) {
      return;
    }
    setReasonStatus("2");
    setOpenReason(true);
    // showAdminLoading();
    // const body = {
    //   draftId: draftIdSelected,
    // };

    // await dispatch(rejectDoc(body));
    // hideAdminLoading();
  };

  const CompleteDocument = async () => {
    if (!window.confirm("Do you want to Complete?")) {
      return;
    }
    showAdminLoading();
    const body = {
      draftId: draftIdSelected,
    };

    await dispatch(completeDoc(body));
    hideAdminLoading();
  };

  const consultSelect = async () => {
    showAdminLoading();
    const body = {
      draftId: draftIdSelected,
    };
    dispatch(clearConsults());
    await dispatch(superaccessList(body));

    setEmpRoleSelected([4]);
    setOpenSupervisor(true);
    hideAdminLoading();
  };

  const requestDoc = async (docs) => {
    showAdminLoading();

    const detail = docs.map((x) => {
      return {
        reqDetDocId: null,
        configDocumentRequiredID: x.configDocumentRequiredID,
        remark: x.remark,
        status: RequestDocStatus.Request,
      };
    });
    const body = {
      reqDocId: null,
      reqDate: format(new Date(), "yyyy-MM-dd"),
      draftId: draftIdSelected,
      remark: null,
      status: RequestDocStatus.Request,
      detail: detail,
    };
    await dispatch(requestDocuments(body));
    hideAdminLoading();
  };

  const departmentApprove = () => {
    const depapprove = configApprveSmartFrom?.find(
      (x) => x.departmentId === profile.departmentId
    );
    return depapprove;
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <DepsApprove
        draftId={draftIdSelected}
        open={openDepApprove}
        id={draftIdSelected}
        onClose={() => {
          setOpenDepApprove(false);
        }}
      />

      <DepsAssignDialog
        draftId={draftIdSelected}
        open={openDepAssign}
        onClose={async (departments, checkpro, fildIdData) => {
          if (departments) {
            showAdminLoading();
            const body = {
              draftId: draftIdSelected,
              isManager: true,
              department: departments.map((x) => ({ departmentId: x })),
            };
            const detailCheck = {
              detail: checkpro,
            };
            const bodyPrint = {
              draftId: draftIdSelected,
              departmentId: profile.departmentId,
            };

            await dispatch(approveDoc(body));
            await dispatch(CheckpropertiesLog(detailCheck));
            await dispatch(Departmentupload(fildIdData));
            const responstPrint = await dispatch(getPrintList(bodyPrint));
            setPrintFileData(responstPrint?.payload);
            // console.log(detailCheck);
            hideAdminLoading();
          }
          setOpenDepAssign(false);
        }}
      />

      <EmployeeListDialog
        roles={empRoleSelected}
        open={open}
        onClose={async (emp) => {
          if (emp) {
            if (!window.confirm("Do you want to transfer?")) {
              return;
            }

            showAdminLoading();
            const body = {
              draftId: draftIdSelected,
              departmentId: emp.departmentId,
              assignID: emp.empId,
              remark: null,
            };
            await dispatch(reassignDoc(body));
            hideAdminLoading();
          }
          setOpen(false);
        }}
      />

      <SupervisorListDialog
        roles={empRoleSelected}
        open={openSupervisor}
        onRemove={async (body) => {
          if (body) {
            showAdminLoading();
            await dispatch(superaccessremove(body));
            const _body = {
              draftId: draftIdSelected,
            };
            dispatch(clearConsults());
            await dispatch(superaccessList(_body));

            hideAdminLoading();
          }
        }}
        onClose={async (body) => {
          if (body) {
            if (!window.confirm("Do you want to consult?")) {
              return;
            }
            showAdminLoading();
            const _body = {
              draftId: draftIdSelected,
              approveID: body.emp.empId,
              remark: body.remark,
            };

            await dispatch(consultDoc(_body));

            dispatch(clearConsults());
            await dispatch(superaccessList({ draftId: draftIdSelected }));

            hideAdminLoading();
            setOpenSupervisor(false);
          } else {
            setOpenSupervisor(false);
          }
        }}
      />

      <RequestLogs
        open={openReqLogs}
        onClose={() => {
          setOpenReqLogs(false);
        }}
      />

      <ReasonDialog
        open={openReason}
        status={ReasonStatus}
        onClose={() => {
          setOpenReason(false);
        }}
        onReject={async (reason_txt) => {
          showAdminLoading();
          const body = {
            draftId: draftIdSelected,
            reason: reason_txt
          };
          const bodyReason = {
            configReasonID: null,
            draftId: draftIdSelected,
            isPass: false,
            commentToDirector: reason_txt,
          };

          await dispatch(rejectDoc(body));
          await dispatch(ReasonOtherdep(bodyReason));
          hideAdminLoading();
        }}
        onApprove={async (reason_txt) => {
          showAdminLoading();
          const body = {
            draftId: draftIdSelected,
          };
          const bodyReason = {
            configReasonID: null,
            draftId: draftIdSelected,
            isPass: true,
            commentToDirector: reason_txt,
          };
          await dispatch(otherApproveDoc(body));
          await dispatch(ReasonOtherdep(bodyReason));
          hideAdminLoading();
        }}
      />

      <RequestDocs
        open={openReqDocs}
        onClose={async (docs) => {
          setOpenReqDocs(false);
          if (docs) {
            await requestDoc(docs);
          }
        }}
      />

      <ReturnRemarkDialog
        open={openReturnRemark}
        onClose={() => {
          setOpenReturnRemark(false)
        }}
        onConfirm={returnToDraft}
      />

      {
        /* #region Request Additional Information   */
        departmentApprove()?.statusProcessId ===
        STATUS_PROCESS.RequestAddDoc && (
          <div className={classes.wrapRequestDocPending}>
            Request Additional Information
          </div>
        )
        /* #endregion */
      }

      {
        /* #region  Processing ส่งเรื่องไปที่หน่วยงานอื่น */
        profile.departmentId === boiDepartmentId &&
        statusProcessId === STATUS_PROCESS.Draft &&
        docDetail?.smartNo && (
          <div style={{ fontSize: "16px", color: "dimgray" }}>
            Waiting for user edit.
          </div>
        )
        /* #endregion */
      }

      {
        /* #region  Processing ส่งเรื่องไปที่หน่วยงานอื่น */
        profile.departmentId === boiDepartmentId &&
        statusProcessId !== STATUS_PROCESS.ReviewingHealthInsurance &&
        departmentApprove()?.statusProcessId ===
        STATUS_PROCESS.Processing && (
          <div style={{ fontSize: "16px", color: "dimgray" }}>
            Processing{" "}
            {
              configApprveSmartFrom.filter(
                (x) =>
                  x.statusProcessId === STATUS_PROCESS.Processing ||
                  x.statusProcessId === STATUS_PROCESS.Approved ||
                  x.statusProcessId === STATUS_PROCESS.Rejected
              ).length
            }{" "}
            / {configApprveSmartFrom.length}
          </div>
        )
        /* #endregion */
      }

      {
        /* #region  กรณี Other Dep อนุมัติ */
        profile.departmentId !== boiDepartmentId &&
        statusProcessId !== STATUS_PROCESS.FinalApproved &&
        statusProcessId !== STATUS_PROCESS.ReviewingHealthInsurance &&
        departmentApprove()?.statusProcessId === STATUS_PROCESS.Approved && (
          <div style={{ fontSize: "16px", color: "#2DCE98" }}>Approved</div>
        )
        /* #endregion */
      }

      {
        /* #region  กรณี Other Dep ยกเลิก */
        profile.departmentId !== boiDepartmentId &&
        statusProcessId === STATUS_PROCESS.Rejected &&
        departmentApprove()?.statusProcessId === STATUS_PROCESS.Rejected && (
          <div style={{ fontSize: "16px", color: "#F53C56" }}>Rejected</div>
        )
        /* #endregion */
      }

      {
        /* #region  กรณี BOI ยกเลิก */
        profile.departmentId === boiDepartmentId &&
        statusProcessId === STATUS_PROCESS.Rejected &&
        departmentApprove()?.statusProcessId === STATUS_PROCESS.Rejected && (
          <div style={{ fontSize: "16px", color: "#F53C56" }}>Rejected</div>
        )
        /* #endregion */
      }

      {
        /* #region  Final Reviewing */
        profile.departmentId === boiDepartmentId &&
        statusProcessId === STATUS_PROCESS.FinalReviewing && (
          <div style={{ fontSize: "16px", color: "#2DCE98" }}>
            Final Reviewing
          </div>
        )
        /* #endregion */
      }

      {
        /* #region  Final Reviewing  Director*/
        profile.departmentId === boiDepartmentId &&
        statusProcessId === STATUS_PROCESS.FinalReviewingDirector && (
          <div style={{ fontSize: "16px", color: "#2DCE98" }}>
            Final Reviewing Director
          </div>
        )
        /* #endregion */
      }

      {
        /* #region  Final Approved */
        statusProcessId === STATUS_PROCESS.FinalApproved && (
          <div style={{ fontSize: "16px", color: "#2DCE98" }}>
            Final Approved
          </div>
        )
        /* #endregion */
      }

      {
        /* #region  Final Rejected */
        statusProcessId === STATUS_PROCESS.FinalRejected && (
          <div style={{ fontSize: "16px", color: "#F53C56" }}>
            Final Rejected
          </div>
        )
        /* #endregion */
      }

      {
        /* #region  Visa Issuance */
        statusProcessId === STATUS_PROCESS.VisaIssuance && (
          <div style={{ fontSize: "16px", color: "#2DCE98" }}>
            Visa Issuance
          </div>
        )
        /* #endregion */
      }

      {
        /* #region  Visa Received */
        statusProcessId === STATUS_PROCESS.VisaReceived && (
          <div style={{ fontSize: "16px", color: "#2DCE98" }}>
            Visa Received
          </div>
        )
        /* #endregion */
      }

      {
        /* #region Reviewing Health Insurance */
        statusProcessId === STATUS_PROCESS.ReviewingHealthInsurance && (
          <div style={{ fontSize: "16px", color: "#2DCE98" }}>
            Reviewing Health Insurance
          </div>
        )
        /* #endregion */
      }
      {
        /* #region  Complete */
        statusProcessId === STATUS_PROCESS.Complete && (
          <div style={{ fontSize: "16px", color: "#2DCE98" }}>Complete</div>
        )
        /* #endregion */
      }

      {
        /* #region  SentManager */
        departmentApprove()?.statusProcessId === STATUS_PROCESS.SentManager &&
        profile?.roleId === RoleId.Staff && (
          <div style={{ fontSize: "16px", color: "#2DCE98" }}>
            Waiting for supervisor
          </div>
        )
        /* #endregion */
      }

      {/* // Staff BOI  */}
      {isBOI && // เป็น Admin ของ BOI
        profile?.userID === staffID && // ไดัรับมอบหมายในเอกสารนั้น
        profile?.roleId === RoleId.Staff && ( // role = staff
          <>
            {/* {
            (statusProcessId === STATUS_PROCESS.ReviewingHealthInsurance) &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="contained"
              color="success"
              onClick={async () => {
                await reviewHealthInsurance();
              }}
            >
              Review
            </ColorButton>
          } */}

            {
              /* #region  boireceived */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="contained"
                  color="success"
                  onClick={async () => {
                    await boiRecievedDoc();
                  }}
                >
                  RECEIVE
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #region  Sent to other dep */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.BoiRecieved ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="contained"
                  color="success"
                  onClick={async () => {
                    await boiApproveDoc();
                  }}
                >
                  Sent
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #region  Reject (No other dep approve,reject) */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.BoiRecieved ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="outlined"
                  color="error"
                  onClick={async () => {
                    await rejectDocument();
                  }}
                >
                  Reject
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #region  return to other dep */
              departmentApprove()?.statusProcessId ===
              STATUS_PROCESS.Pending && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="contained"
                  color="warning"
                  onClick={async () => {
                    setOpenReturnRemark(true)
                  }}
                >
                  Return
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #Complete When  TypeDocSmartFromID = C*/
              docDetail?.typeDocSmartFromID === STATUS_PROCESS.Complete &&
              statusProcessId === STATUS_PROCESS.Pending && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="contained"
                  color="info"
                  onClick={async () => {
                    await CompleteDocument();
                  }}
                >
                  Complete
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #region  Undo after sent,reject */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Processing ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Rejected) &&
              configApprveSmartFrom.filter(
                (x) =>
                  x.departmentId !== boiDepartmentId &&
                  x.statusProcessId != STATUS_PROCESS.Pending
              ).length === 0 && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="outlined"
                  color="error"
                  onClick={async () => {
                    await boiUndoDoc();
                  }}
                >
                  Undo
                </ColorButton>
              )
              /* #endregion */
            }

            <div
              style={{
                height: "40px",
                width: "2px",
                backgroundColor: "lightgray",
                marginLeft: "15px",
                marginRight: "15px",
              }}
            ></div>

            {
              /* #region  Consult (Send Manager) */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.BoiRecieved ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) && (
                <ColorButton
                  className={classes.buttonInfo}
                  variant="contained"
                  onClick={async () => {
                    consultSelect();
                  }}
                >
                  Consult
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #region  ขอเอกสารเพิ่มเติม */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.BoiRecieved ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.RequestAddDoc ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) && (
                <ColorButton
                  className={classes.buttonInfo}
                  variant="contained"
                  onClick={async () => {
                    setOpenReqDocs(true);
                  }}
                >
                  Request
                </ColorButton>
              )
              /* #endregion */
            }
          </>
        )}

      {/* // BOI Supervisor */}
      {isBOI && // เป็น Admin ของ BOI
        profile?.roleId === RoleId.Supervisor &&
        consults.find((x) => x.empId === profile?.userID) && (
          <>
            {
              /* #region สามารถ sent ไปหน่วยงานอื่นได้ หลังจาก staff sent manager  */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="contained"
                  color="success"
                  onClick={async () => {
                    await boiApproveDoc();
                  }}
                >
                  Sent
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #region สามารถ reject ได้ หลังจาก staff sent manager  */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="outlined"
                  color="error"
                  onClick={async () => {
                    await rejectDocument();
                  }}
                >
                  Reject
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #region  สามารถยกเลิก การอนุมัติก่อนหน้า (Approve, Reject) กรณีที่  ยังไม่มีหน่วยไหน approve, reject */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Rejected ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Processing) && // จะต้องเป็นสถานะ (Approve, Reject)
              configApprveSmartFrom.filter(
                (x) =>
                  x.departmentId !== boiDepartmentId &&
                  x.statusProcessId != STATUS_PROCESS.Pending
              ).length === 0 && ( // จะต้องไม่มีหน่วยงานไหน approve
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="outlined"
                  color="error"
                  onClick={async () => {
                    await boiUndoDoc();
                  }}
                >
                  Undo
                </ColorButton>
              )
              /* #endregion */
            }

            <div
              style={{
                height: "40px",
                width: "2px",
                backgroundColor: "lightgray",
                marginLeft: "15px",
                marginRight: "15px",
              }}
            ></div>

            {/* {
            // ส่งเรื่องไปยัง Manager, Director
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.RequireDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.SendManagement ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.SendRequest) && 
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                consultSelect();
              }}
            >
              Consult
            </ColorButton>
          } */}

            {
              /* #region มอบหมายงานให้คนอื่น  */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) && (
                <ColorButton
                  className={classes.buttonInfo}
                  variant="contained"
                  onClick={async () => {
                    setEmpRoleSelected([4]);
                    setOpen(true);
                  }}
                >
                  Reassign
                </ColorButton>
              )
              /* #endregion */
            }

            {
              // ขอเอกสารเพิ่มเติม
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.RequestAddDoc ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) && ( //  status เป็น pending || sent manager
                <ColorButton
                  className={classes.buttonInfo}
                  variant="contained"
                  onClick={async () => {
                    setOpenReqDocs(true);
                  }}
                >
                  Request
                </ColorButton>
              )
            }
          </>
        )}

      {/* // BOI Director */}
      {isBOI && // เป็น Admin ของ BOI
        profile?.roleId === RoleId.Director && (
          <>
            {
              /* #region  สามารถ sent ไปหน่วยงานอื่นได้ */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager) && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="contained"
                  color="success"
                  onClick={async () => {
                    await boiApproveDoc();
                  }}
                >
                  Sent
                </ColorButton>
              )
              /* #endregion */
            }

            {
              // สามารถยกเลิกใบคำร้อง
              (/*departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Reviewing ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.ReturnPreapproved*/
                departmentApprove()?.statusProcessId !== STATUS_PROCESS.FinalRejected &&
                departmentApprove()?.statusProcessId !== STATUS_PROCESS.Rejected
              ) && ( //  status เป็น pending || sent manager
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="outlined"
                  color="error"
                  onClick={async () => {
                    await rejectDocument();
                  }}
                >
                  Reject
                </ColorButton>
              )
            }

            {
              /* #region สามารถยกเลิก การอนุมัติก่อนหน้า (Approve, Reject) กรณีที่ยังไม่มีหน่วยไหน approve, reject  */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Rejected ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Processing) &&
              configApprveSmartFrom.filter(
                (x) =>
                  x.departmentId !== boiDepartmentId &&
                  x.statusProcessId != STATUS_PROCESS.Pending
              ).length === 0 && ( // จะต้องไม่มีหน่วยงานไหน approve
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="outlined"
                  color="error"
                  onClick={async () => {
                    await boiUndoDoc();
                  }}
                >
                  Undo
                </ColorButton>
              )
              /* #endregion */
            }

            <div
              style={{
                height: "40px",
                width: "2px",
                backgroundColor: "lightgray",
                marginLeft: "15px",
                marginRight: "15px",
              }}
            ></div>

            {/* {
            // ส่งเรื่องไปยัง Manager, Director
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.RequireDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.SendManagement ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.SendRequest) &&   //  status เป็น pending || sent manager
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {

                consultSelect();
              }}
            >
              Consult
            </ColorButton>
          } */}

            {
              // มอบหมายงานให้คนอื่น
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) && ( //  status เป็น pending || sent manager
                <ColorButton
                  className={classes.buttonInfo}
                  variant="contained"
                  onClick={async () => {
                    setEmpRoleSelected([4]);
                    setOpen(true);
                  }}
                >
                  Reassign
                </ColorButton>
              )
            }

            {
              // ขอเอกสารเพิ่มเติม
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.RequestAddDoc ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) && ( //  status เป็น pending || sent manager
                <ColorButton
                  className={classes.buttonInfo}
                  variant="contained"
                  onClick={async () => {
                    setOpenReqDocs(true);
                  }}
                >
                  Request
                </ColorButton>
              )
            }

            {
              // Force Approve
              statusProcessId === STATUS_PROCESS.FinalReviewing && (
                <ColorButton
                  style={{ height: 40, marginLeft: 20 }}
                  variant="contained"
                  color="success"
                  onClick={async () => {
                    forceDocStatus(true);
                  }}
                >
                  Force Approve
                </ColorButton>
              )
            }

            {
              // Force Reject
              statusProcessId === STATUS_PROCESS.FinalReviewing && (
                <ColorButton
                  style={{ height: 40, marginLeft: 20 }}
                  variant="outlined"
                  color="error"
                  onClick={async () => {
                    forceDocStatus(false);
                  }}
                >
                  Force Reject
                </ColorButton>
              )
            }
          </>
        )}

      {/* // Staff OtherDep  */}
      {isOther && // เป็น Admin ของ BOI
        profile?.roleId === RoleId.Staff &&
        departmentApprove()?.departmentId === profile.departmentId &&
        departmentApprove()?.empId === profile.userID && (
          <>
            {
              /* #region หน่วยงานอื่นอนุมัติ  */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) &&
              statusProcessId !== STATUS_PROCESS.FinalRejected && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="contained"
                  color="success"
                  onClick={async () => {
                    await otherApprove();
                  }}
                >
                  Approve
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #region  other dep ยกเลิกใบคำร้อง */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) &&
              statusProcessId !== STATUS_PROCESS.FinalRejected && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="outlined"
                  color="error"
                  onClick={async () => {
                    await rejectDocument();
                  }}
                >
                  Reject
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #region  other dep undo (approved, rejected) */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Approved ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Rejected) &&
              statusProcessId === STATUS_PROCESS.Processing && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="outlined"
                  color="error"
                  onClick={async () => {
                    await otherUndoDoc();
                  }}
                >
                  Undo
                </ColorButton>
              )
              /* #endregion */
            }

            <div
              style={{
                height: "40px",
                width: "2px",
                backgroundColor: "lightgray",
                marginLeft: "15px",
                marginRight: "15px",
              }}
            ></div>

            {
              /* #region other dep ส่งเรื่องไปยัง Manager, Director */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) &&
              statusProcessId !== STATUS_PROCESS.FinalRejected && (
                <ColorButton
                  className={classes.buttonInfo}
                  variant="contained"
                  onClick={async () => {
                    consultSelect();
                  }}
                >
                  Consult
                </ColorButton>
              )
              /* #endregion */
            }
            {/* {
            // มอบหมายงานให้คนอื่น
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Pending ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.RequireDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.SendManagement ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.SendRequest)
            &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                setEmpRoleSelected([4])
                setOpen(true);
              }}
            >
              Reassign
            </ColorButton>
          } */}

            {
              /* #region other dep ขอเอกสารเพิ่มเติม  */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.RequestAddDoc ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) &&
              (statusProcessId === STATUS_PROCESS.Processing ||
                statusProcessId === STATUS_PROCESS.RequestAddDoc) && (
                <ColorButton
                  className={classes.buttonInfo}
                  variant="contained"
                  onClick={async () => {
                    setOpenReqDocs(true);
                  }}
                >
                  Request
                </ColorButton>
              )
              /* #endregion */
            }
          </>
        )}

      {/* // Supervisor OtherDep  */}
      {isOther && // เป็น Admin ของ BOI
        profile?.roleId === RoleId.Supervisor &&
        consults.find((x) => x.empId === profile?.userID) &&
        departmentApprove()?.departmentId === profile.departmentId && (
          <>
            {
              /* #region other dep อนุมัติใบคำขอ  */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) &&
              statusProcessId !== STATUS_PROCESS.FinalRejected && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="contained"
                  color="success"
                  onClick={async () => {
                    await otherApprove();
                  }}
                >
                  Approve
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #region other dep  Reject ใบคำขอ */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) &&
              statusProcessId !== STATUS_PROCESS.FinalRejected && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="outlined"
                  color="error"
                  onClick={async () => {
                    await rejectDocument();
                  }}
                >
                  Reject
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #region  Other dep undo */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Approved ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Rejected ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) &&
              statusProcessId === STATUS_PROCESS.Processing && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="outlined"
                  color="error"
                  onClick={async () => {
                    await otherUndoDoc();
                  }}
                >
                  Undo
                </ColorButton>
              )
              /* #endregion */
            }

            <div
              style={{
                height: "40px",
                width: "2px",
                backgroundColor: "lightgray",
                marginLeft: "15px",
                marginRight: "15px",
              }}
            ></div>

            {/* {

            (departmentApprove()?.statusProcessId === STATUS_PROCESS.Processing ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.UploadAddDoc) &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                consultSelect();
              }}
            >
              Consult
            </ColorButton>
  
          } */}
            {
              // มอบหมายงานให้คนอื่น
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) &&
              statusProcessId === STATUS_PROCESS.Processing && (
                <ColorButton
                  className={classes.buttonInfo}
                  variant="contained"
                  onClick={async () => {
                    setEmpRoleSelected([4]);
                    setOpen(true);
                  }}
                >
                  Reassign
                </ColorButton>
              )
            }

            {
              // ขอเอกสารเพิ่มเติม
              (
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                // departmentApprove()?.statusProcessId ===
                // STATUS_PROCESS.RequestAddDoc ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) &&
              (statusProcessId === STATUS_PROCESS.Processing ||
                statusProcessId === STATUS_PROCESS.RequestAddDoc) && (
                <ColorButton
                  className={classes.buttonInfo}
                  variant="contained"
                  onClick={async () => {
                    setOpenReqDocs(true);
                  }}
                >
                  Request
                </ColorButton>
              )
            }
          </>
        )}

      {/* // Director OtherDep  */}
      {isOther && // เป็น Admin ของ BOI
        profile?.roleId === RoleId.Director &&
        departmentApprove()?.departmentId === profile.departmentId && (
          <>
            {
              /* #region  Director other dep approve */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending) &&
              statusProcessId !== STATUS_PROCESS.FinalRejected && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="contained"
                  color="success"
                  onClick={async () => {
                    await otherApprove();
                  }}
                >
                  Approve
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #region Director other dep reject  */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Pending) &&
              statusProcessId !== STATUS_PROCESS.FinalRejected && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="outlined"
                  color="error"
                  onClick={async () => {
                    await rejectDocument();
                  }}
                >
                  Reject
                </ColorButton>
              )
              /* #endregion */
            }

            {
              /* #region  Director other dep  undo */
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Approved ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.Rejected) &&
              statusProcessId === STATUS_PROCESS.Processing && (
                <ColorButton
                  style={{ height: 40, width: 125, marginLeft: 20 }}
                  variant="outlined"
                  color="error"
                  onClick={async () => {
                    await otherUndoDoc();
                  }}
                >
                  Undo
                </ColorButton>
              )
              /* #endregion */
            }

            <div
              style={{
                height: "40px",
                width: "2px",
                backgroundColor: "lightgray",
                marginLeft: "15px",
                marginRight: "15px",
              }}
            ></div>

            {/* {
            // ส่งเรื่องไปยัง Manager, Director
            (departmentApprove()?.statusProcessId === STATUS_PROCESS.SendManagement ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.RequireDoc ||
              departmentApprove()?.statusProcessId === STATUS_PROCESS.Sent) &&
            <ColorButton
              className={classes.buttonInfo}
              variant="contained"
              onClick={async () => {
                consultSelect();
              }}
            >
              Consult
            </ColorButton>
          } */}
            {
              // มอบหมายงานให้คนอื่น
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) &&
              statusProcessId === STATUS_PROCESS.Processing && (
                <ColorButton
                  className={classes.buttonInfo}
                  variant="contained"
                  onClick={async () => {
                    setEmpRoleSelected([4]);
                    setOpen(true);
                  }}
                >
                  Reassign
                </ColorButton>
              )
            }

            {
              // ขอเอกสารเพิ่มเติม
              (departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.SentManager ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.RequestAddDoc ||
                departmentApprove()?.statusProcessId ===
                STATUS_PROCESS.UploadAddDoc) &&
              (statusProcessId === STATUS_PROCESS.Processing ||
                statusProcessId === STATUS_PROCESS.RequestAddDoc) && (
                <ColorButton
                  className={classes.buttonInfo}
                  variant="contained"
                  onClick={async () => {
                    setOpenReqDocs(true);
                  }}
                >
                  Request
                </ColorButton>
              )
            }
          </>
        )}

      <MoreVertIcon
        className={classes.buttonStatusDetail}
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
        }}
      />

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        {profile?.departmentId === boiDepartmentId && (
          <MenuItem
            onClick={async () => {
              setAnchorEl(null);
              setOpenDepApprove(true);
            }}
          >
            Deps Approve
          </MenuItem>
        )}
        <MenuItem
          onClick={async () => {
            await dispatch(docLogs({ draftId: draftIdSelected }));
            setAnchorEl(null);
            setOpenReqLogs(true);
          }}
        >
          Logs
        </MenuItem>

        {statusProcessId === STATUS_PROCESS.Complete && (
          <MenuItem
            onClick={async () => {
              const fileFullName = `${draftIdSelected}.pdf`;
              const blob = await ReportService.getResultSmartfromDetail({
                draftId: draftIdSelected,
              });

              const blobFile = new File([blob], fileFullName, {
                type: mime.getType(".pdf"),
              });

              window.open(URL.createObjectURL(blobFile), "_blank");
            }}
          >
            Download
          </MenuItem>
        )}
      </Menu>

      {PrintFileData?.length > 0 ? (
        <>
          <Button
            id="basic-buttonPrint"
            aria-controls={openPrint ? "basic-menuPrint" : undefined}
            aria-haspopup="true"
            aria-expanded={openPrint ? "true" : undefined}
            onClick={handleClickPrint}
            variant="outlined"
            color="primary"
            style={{ marginLeft: 10 }}
          >
            Print
          </Button>
          <Menu
            id="basic-menuPrint"
            anchorEl={anchorElPrint}
            open={openPrint}
            onClose={handleClosePrint}
            MenuListProps={{
              "aria-labelledby": "basic-buttonPrint",
            }}
          >
            {PrintFileData?.map((x, index) => (
              <MenuItem
                key={index}
                onClick={async () => {
                  const data = await FileService.getFile(x.fileID);

                  const blobFile = new File([data], x.filename + x.ext, {
                    type: mime.getType(x.ext),
                  });

                  window.open(
                    URL.createObjectURL(blobFile, x.filename + x.ext),
                    "_blank"
                  );
                }}
              >
                หนังสือนำส่ง {x.departmentName}
              </MenuItem>
            ))}
          </Menu>
        </>
      ) : null}

      {(statusProcessId === STATUS_PROCESS.FinalReviewing ||
        statusProcessId === STATUS_PROCESS.FinalReviewingDirector) &&
        profile.departmentId === boiDepartmentId && (
          <Typography
            style={{
              marginLeft: "10px",
              textDecoration: "underline",
              color: "#00D0FF",
              cursor: "pointer",
            }}
            onClick={() => {
              if (_Role === RoleId.Admin || _Role === RoleId.Staff) {
                window.open(
                  `/admin/smart-visa/view-reason/${draftIdSelected}`,
                  "_blank"
                );
              }
              if (_Role === RoleId.Director) {
                window.open(
                  `/admin/smart-visa/view-reason-director/${draftIdSelected}`,
                  "_blank"
                );
              }
            }}
          >
            View Reason
          </Typography>
        )}
    </div>
  );
}

function SupervisorListDialog(props) {
  const classes = useStyles();
  const { onClose, open, roles, onRemove } = props;
  const { profile } = useSelector((state) => state.user);

  const { consults } = useSelector((state) => state.allDocuments);

  const handleClose = () => {
    onClose();
  };

  const employees = useSelector((state) => {
    return state.employee.list.filter(
      (x) =>
        roles.indexOf(x.roleLevel) > -1 &&
        x.departmentId === profile.departmentId
    );
  });

  const dispatch = useDispatch();
  const validationSchema = yup.object({
    empId: yup.string().ensure().required("Employee is required."),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      empId: null,
      remark: "",
    },
    onSubmit: async (values) => {
      const emp = employees.find((x) => x.empId === values.empId);
      formik.setFieldValue("remark", null);
      onClose({ emp: emp, remark: values.remark });
    },
  });

  useEffect(async () => {
    if (open) {
      formik.resetForm();
    }
  }, [open]);

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>
        Consult
      </DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit} id="emp-form">
          <div>
            <Grid container>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                {consults.length > 0 && (
                  <>
                    <div
                      style={{
                        color: "#8898aa",
                        marginBottom: 10,
                        fontSize: "16px",
                      }}
                    >
                      Consult List
                    </div>
                  </>
                )}

                {consults
                  .filter((x) => x.departmentId === profile.departmentId)
                  .map((c, index) => (
                    <>
                      <div className={classes.superwrapSupervisorList}>
                        <div key={c.docAccID}>
                          {index + 1}. {c.empFirstname} {c.empLastname}
                        </div>
                        <div>
                          <CloseIcon
                            className={classes.superremove}
                            onClick={async () => {
                              if (
                                !window.confirm(
                                  "Do you want to remove this consultant?"
                                )
                              ) {
                                return;
                              }

                              const body = {
                                docAccID: c.docAccID,
                                status: false,
                              };
                              onRemove(body);
                            }}
                          />
                        </div>
                      </div>
                    </>
                  ))}
              </Grid>

              {consults.length > 0 && <hr />}

              <Grid
                item
                xs={12}
                md={12}
                className={classes.warpFormControl}
                style={{ marginTop: 15 }}
              >
                <InputLabel className={classes.d2title}>Supervisor</InputLabel>
              </Grid>

              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    name="empId"
                    className={classes.root}
                    value={formik.values.empId}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("empId", formik)}
                  >
                    {employees
                      .map((v) => v)
                      .filter(
                        (x) =>
                          consults.map((c) => c.empId).indexOf(x.empId) === -1
                      )
                      .sort(sortByName("employeeFistName"))
                      .map((p) => (
                        <MenuItem key={p.empId} value={p.empId}>
                          {p.employeeFistName} {p.employeeLastName}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText error={isError("empId", formik)}>
                    {getErrorMessage("empId", formik)}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                className={classes.warpFormControl}
                style={{ marginTop: 15 }}
              >
                <InputLabel className={classes.d2title}>Remark</InputLabel>
              </Grid>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <TextField
                    variant="outlined"
                    name={`remark`}
                    value={formik.values.remark}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError(`remark`, formik)}
                    helperText={getErrorMessage(`remark`, formik)}
                    className={classes.textDialog}
                    multiline
                    rows={5}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button
                  variant="outlined"
                  size="medium"
                  type="button"
                  color="primary"
                  onClick={() => handleClose()}
                  className={classes.buttonDialogSave}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  size="medium"
                  type="submit"
                  color="primary"
                  className={classes.buttonDialogSave}
                >
                  Submit
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
}

function EmployeeListDialog(props) {
  const classes = useStyles();
  const { onClose, open, roles } = props;

  const { profile } = useSelector((state) => state.user);

  const handleClose = () => {
    onClose();
  };

  const employees = useSelector((state) => {
    return state.employee.list.filter(
      (x) =>
        roles.indexOf(x.roleLevel) > -1 &&
        x.departmentId === profile.departmentId
    );
  });

  const validationSchema = yup.object({
    empId: yup.string().required("Employee is required."),
    // startDate: yup.date().required("Date is required."),
    // remark: yup.string().required("Holiday name is required."),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      empId: null,
    },
    onSubmit: async (values) => {
      const emp = employees.find((x) => x.empId === values.empId);
      onClose(emp);
    },
  });

  useEffect(async () => {
    if (open) {
      formik.resetForm();
    }
  }, [open]);

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>
        เลือกพนักงาน
      </DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit} id="emp-form">
          <div className={classes.warpRowDialog}>
            <Grid container>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <InputLabel className={classes.d2title}>พนักงาน</InputLabel>
              </Grid>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    name="empId"
                    className={classes.root}
                    value={formik.values.empId}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("empId", formik)}
                  >
                    {employees
                      .map((v) => v)
                      .sort(sortByName("employeeFistName"))
                      .map((p) => (
                        <MenuItem key={p.empId} value={p.empId}>
                          {p.employeeFistName} {p.employeeLastName}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText error={isError("empId", formik)}>
                    {getErrorMessage("empId", formik)}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button
                  variant="outlined"
                  size="medium"
                  type="button"
                  color="primary"
                  onClick={() => handleClose()}
                  className={classes.buttonDialogSave}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  size="medium"
                  type="submit"
                  color="primary"
                  className={classes.buttonDialogSave}
                >
                  Submit
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
}

function ReasonDialog(props) {
  const classes = useStyles();
  const { onClose, open, status, roles, onReject, onApprove, ReasonText } =
    props;

  const { profile } = useSelector((state) => state.user);

  const handleClose = () => {
    onClose();
  };

  const validationSchema = yup.object({
    // reason_txt:
    //   status === 1
    //     ? yup.string()
    //     : yup.string().required("Reason is required."),
    reason_txt: yup.string().when("status", {
      is: (value) => value === "1",
      then: yup.string(),
      otherwise: yup.string().required("Reason is required."),
    }),
    // startDate: yup.date().required("Date is required."),
    // remark: yup.string().required("Holiday name is required."),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      reason_txt: "",
      status: status,
    },
    onSubmit: async (values) => {
      if (status === "1") {
        onApprove(values.reason_txt);
      } else {
        onReject(values.reason_txt);
      }
      onClose();
    },
  });

  useEffect(async () => {
    if (open) {
      formik.resetForm();
    }
  }, [open]);

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>
        Reason
      </DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit} id="emp-form">
          <div className={classes.warpRowDialog}>
            <Grid container>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <TextField
                    variant="outlined"
                    name={`reason_txt`}
                    value={formik.values.reason_txt}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError(`reason_txt`, formik)}
                    helperText={getErrorMessage(`reason_txt`, formik)}
                    className={classes.textDialog}
                    multiline
                    rows={5}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button
                  variant="outlined"
                  size="medium"
                  type="button"
                  color="primary"
                  onClick={() => handleClose()}
                  className={classes.buttonDialogSave}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="medium"
                  type="submit"
                  color="primary"
                  className={classes.buttonDialogSave}
                >
                  OK
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
}

function DepsAssignDialog(props) {
  const classes = useStyles();
  const { onClose, open, draftId } = props;
  const dispatch = useDispatch();
  const masterData = useSelector(selectMasterData);
  const departmentData = get(masterData, "department", []);
  const { configApprveSmartFrom, smartserviceId } = useSelector(
    (state) => state.allDocuments.detail
  );
  const [departments, setDepartments] = useState([]);
  const [checkpro, setCheckpro] = useState([]);
  const [checkProSelect, setCheckproSelect] = useState([]);
  const [isCheck, setIsCheck] = useState(false);
  const [arrFileId, setarrFileId] = useState([]);

  useEffect(async () => {
    if (departmentData && smartserviceId) {
      const resConfigDepartments =
        await ConfigSmartServiceService.getConfigSmartService({
          smartServiceId: smartserviceId,
        });

      if (resConfigDepartments.status) {
        const configDepartments = resConfigDepartments.results;
        const departmentsRaw = departmentData
          .filter((x) => x.departmentId !== boiDepartmentId)
          .map((x) => {
            return {
              ...x,
              checked: configDepartments?.find(
                (x1) => x.departmentId === x1.departmentId
              ),
              file: "",
            };
          });
        setDepartments(departmentsRaw);
        getCheckpropertiesdep();
      }
    }
  }, [departmentData, smartserviceId]);

  useEffect(async () => {
    async function mergedFetchData() {
      await dispatch(
        getMasterData({
          smartservice: true,
          department: true,
        })
      );
    }
    mergedFetchData();
  }, []);

  const handleClose = () => {
    onClose();
  };

  const getCheckpropertiesdep = async () => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/checkpropertiesdep/list`
      );
      if (response.status) {
        setCheckpro(response.results);
        return response;
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const saveCheckPro = (data) => {
    const index = checkProSelect.findIndex(
      (obj) =>
        obj.checkpropertiesID === data.checkpropertiesID &&
        obj.departmentId === data.departmentId
    );

    if (index > -1) {
      //make sure you found it
      checkProSelect.splice(index, 1);
      setCheckproSelect([...checkProSelect]);
    } else {
      const body = {
        draftId: draftId,
        departmentId: data.departmentId,
        checkpropertiesID: data.checkpropertiesID,
        status: true,
      };

      setCheckproSelect([...checkProSelect, body]);
    }
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>
        หน่วยงานที่ตรวจสอบ
      </DialogTitle>
      <DialogContent>
        <div className={classes.rowMenuPopOver}>
          {departments?.map((row, index) => (
            <>
              <div key={row.departmentId} className={classes.rowPopItem}>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      checked={row.checked}
                      onClick={(event) => {
                        const _deps = departments.map((item, index2) =>
                          index === index2
                            ? {
                              ...item,
                              checked: event.target.checked,
                              file: event.target.checked ? item.file : "",
                            }
                            : item
                        );
                        setDepartments(_deps);

                        const newData = arrFileId.filter((x) => {
                          if (
                            x.departmentId == row.departmentId &&
                            !event.target.checked
                          ) {
                            return false;
                          } else {
                            return true;
                          }
                        });
                        setarrFileId(newData);
                      }}
                    />
                  }
                  label={row.departmentName}
                />
                {row?.checked ? (
                  <>
                    <UploadButton
                      title={row?.file !== "" ? "Edit" : "+ Add"}
                      name={index}
                      id={index}
                      onChange={async (event) => {
                        try {
                          const response = await FileService.uploadFile({
                            file: event.target.files[0],
                            Status: true,
                          });

                          // const fileId = response.results?.fileID;
                          // const [filename, ext] =
                          //   event.target.files[0].name.split(".");
                          const _deps = departments.map((item, index2) =>
                            index === index2
                              ? {
                                ...item,
                                file: event.target.files[0].name,
                              }
                              : item
                          );
                          const findId = arrFileId.find(
                            (x) => x.departmentId === row.departmentId
                          );
                          if (findId) {
                            const newData = arrFileId.map((x) => {
                              if (x.departmentId == row.departmentId) {
                                return {
                                  draftId: draftId,
                                  departmentId: row.departmentId,
                                  fileId: response.results.fileID,
                                  status: true,
                                };
                              } else {
                                return x;
                              }
                            });
                            setarrFileId(newData);
                          } else {
                            setarrFileId([
                              ...arrFileId,
                              {
                                draftId: draftId,
                                departmentId: row.departmentId,
                                fileId: response.results.fileID,
                                status: true,
                              },
                            ]);
                          }

                          setDepartments(_deps);
                        } catch (error) {
                          console.log("Upload error", error);
                        }
                      }}
                    />

                    <Typography>{row.file}</Typography>
                  </>
                ) : null}
              </div>

              {row?.checked ? (
                <div style={{ marginLeft: "30px" }}>
                  {checkpro
                    .filter((x) => x.departmentId === row.departmentId)
                    .map((sub) => (
                      <>
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              // checked={}
                              onClick={(event) => {
                                saveCheckPro(sub);
                              }}
                            />
                          }
                          label={sub.checkpropertiesName}
                        />
                      </>
                    ))}
                </div>
              ) : null}
            </>
          ))}

          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button
                  variant="outlined"
                  size="medium"
                  color="primary"
                  onClick={() => handleClose()}
                  className={classes.buttonDialogSave}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  size="medium"
                  color="primary"
                  onClick={() => {
                    // const checks = departments?.filter((xs) => xs.checked);

                    // let checkFail = 0;
                    // checks.map((x) => {
                    //   const xxx = checkProSelect.filter(
                    //     (xs) => xs.departmentId === x.departmentId
                    //   );

                    //   if (xxx.length === 0) {
                    //     console.log(false);
                    //     checkFail = checkFail + 1;
                    //   } else {
                    //     console.log(true);
                    //   }
                    // });

                    // if (checkFail === 0) {
                    //   const departmentIds = departments
                    //     .filter((x) => x.checked)
                    //     .map((x) => x.departmentId);
                    //   onClose(departmentIds, checkProSelect);
                    // } else {
                    //   alert("กรุณาเลือกตัวเลือกอย่างน้อย 1 หัวข้อ");
                    // }

                    const complete = departments.filter(
                      (x) => x.checked && x.isRequiredUpload && x.file === ""
                    );

                    if (complete.length > 0) {
                      alert("Please Upload File");
                    } else {
                      const departmentIds = departments
                        .filter((x) => x.checked)
                        .map((x) => x.departmentId);
                      onClose(departmentIds, checkProSelect, arrFileId);
                    }
                  }}
                  className={classes.buttonDialogSave}
                >
                  Save
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function DepsApprove(props) {
  const classes = useStyles();
  const { onClose, open, draftId } = props;
  const { configApprveSmartFrom } = useSelector(
    (state) => state.allDocuments.detail
  );
  const [checkproList, setCheckProList] = useState([]);

  const handleListItemClick = () => {
    onClose({});
  };

  const handleClose = () => {
    console.log(configApprveSmartFrom);
    onClose();
  };

  const getCheckpropertiesdep = async () => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/checkpropertiesdepbydraftid/list?draftId=${draftId}`
      );
      if (response.status) {
        setCheckProList(response.results);
        console.log(response.results);
        return response;
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  useEffect(async () => {
    if (open) {
      console.log(configApprveSmartFrom);
      getCheckpropertiesdep();
    }
  }, [open]);

  const printReportQuadepartment = async (departmentId) => {
    const body = {
      draftId: props.id,
      departmentId: departmentId,
    };
    const blob = await AllDocumentsService.getReportquadepartment(body);

    const blobFile = new File([blob], "quadepartment.pdf", {
      type: mime.getType(".pdf"),
    });

    window.open(URL.createObjectURL(blobFile, "quadepartment.pdf"), "_blank");
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>
        หน่วยงานที่ตรวจสอบ
      </DialogTitle>
      <DialogContent>
        <div className={classes.rowMenuPopOver}>
          {configApprveSmartFrom?.map((row, index) => (
            <div key={row.departmentId}>
              {
                // (row.statusProcessId === STATUS_PROCESS.Sent ||
                (row.statusProcessId === STATUS_PROCESS.Complete ||
                  row.statusProcessId === STATUS_PROCESS.Processing ||
                  row.statusProcessId === STATUS_PROCESS.Approved) && (
                  <>
                    <div className={classes.rowPopItem}>
                      <Fragment>
                        <div
                          className={classes.iconPop}
                          style={{ backgroundColor: "#2DCE98" }}
                        >
                          <CheckIcon></CheckIcon>
                        </div>
                        <span>
                          {row.departmentName} ({row.empFirstName}{" "}
                          {row.empLastName} )
                          {/* {row?.departmentId !== boiDepartmentId ? (
                        <Button color="primary" variant="outlined">
                          Print
                        </Button>
                      ) : null} */}
                        </span>
                      </Fragment>
                    </div>
                    <div style={{ marginLeft: "30px" }}>
                      {checkproList
                        .filter((x) => x.departmentId === row.departmentId)
                        .map((sub) => (
                          <>
                            <Typography>- {sub.checkpropertiesName}</Typography>
                          </>
                        ))}
                    </div>
                  </>
                )
              }
              {
                // (row.statusProcessId !== STATUS_PROCESS.Sent &&
                //   row.statusProcessId !== STATUS_PROCESS.Complete &&
                //   row.statusProcessId !== STATUS_PROCESS.Approve &&
                //   row.statusProcessId !== STATUS_PROCESS.Reject
                // ) &&
                row.statusProcessId === STATUS_PROCESS.Pending && (
                  <>
                    <div className={classes.rowPopItem}>
                      <Fragment>
                        <div
                          className={classes.iconPop}
                          style={{ backgroundColor: "#FEB969" }}
                        >
                          <RemoveIcon></RemoveIcon>
                        </div>
                        <span>
                          {row.departmentName} ({row.empFirstName}{" "}
                          {row.empLastName}){" "}
                          {/* {row?.departmentId !== boiDepartmentId ? (
                        <Button
                          color="primary"
                          onClick={() =>
                            printReportQuadepartment(row?.departmentId)
                          }
                          variant="outlined"
                        >
                          Print
                        </Button>
                      ) : null} */}
                        </span>
                      </Fragment>
                    </div>
                    <div style={{ marginLeft: "30px" }}>
                      {checkproList
                        .filter((x) => x.departmentId === row.departmentId)
                        .map((sub) => (
                          <>
                            <Typography>- {sub.checkpropertiesName}</Typography>
                          </>
                        ))}
                    </div>
                  </>
                )
              }

              {(row.statusProcessId === STATUS_PROCESS.Rejected ||
                row.statusProcessId === STATUS_PROCESS.FinalRejected) && (
                  <>
                    <div className={classes.rowPopItem}>
                      <Fragment>
                        <div
                          className={classes.iconPop}
                          style={{ backgroundColor: "#f53c56" }}
                        >
                          <CloseIcon></CloseIcon>
                        </div>
                        <span>
                          {row.departmentName} ({row.empFirstName}{" "}
                          {row.empLastName})
                        </span>
                      </Fragment>
                    </div>
                    <div style={{ marginLeft: "30px" }}>
                      {checkproList
                        .filter((x) => x.departmentId === row.departmentId)
                        .map((sub) => (
                          <>
                            <Typography>- {sub.checkpropertiesName}</Typography>
                          </>
                        ))}
                    </div>
                  </>
                )}
            </div>
          ))}
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button
                  variant="outlined"
                  size="medium"
                  color="primary"
                  onClick={() => handleClose()}
                  className={classes.buttonDialogSave}
                >
                  Close
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function RequestLogs(props) {
  const classes = useStyles();
  const { onClose, open } = props;

  const { logs } = useSelector((state) => state.allDocuments);

  useEffect(async () => { }, [open]);

  const handleListItemClick = () => {
    onClose({});
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>
        ประวัติการทำรายการ
      </DialogTitle>
      <DialogContent>
        <div className={classes.rowMenuPopOver}>
          {logs?.map((row, index) => (
            <div key={row.departmentId}>
              <div className={classes.rowPopItem}>
                <Fragment>
                  <div
                    style={{
                      width: 150,
                    }}
                  >
                    {format(new Date(row.createDate), "yyyy-MM-dd HH:mm")}
                  </div>
                  <span>{row.statusName}</span>
                </Fragment>
              </div>
              <div className={classes.rowPopItem}>
                <Fragment>
                  <div
                    style={{
                      width: 150,
                    }}
                  ></div>
                  <div style={{ color: "darkgray", fontSize: "11px" }}>
                    {row.departmentName}
                  </div>
                </Fragment>
              </div>

              {row.remark && (
                <div className={classes.rowPopItem}>
                  <Fragment>
                    <div
                      style={{
                        width: 150,
                      }}
                    ></div>
                    <div
                      style={{
                        color: "dimgray",
                        fontSize: "0.85em",
                        fontWeight: "400",
                      }}
                    >
                      Remark: {row.remark}
                    </div>
                  </Fragment>
                </div>
              )}
            </div>
          ))}
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button
                  variant="outlined"
                  size="medium"
                  color="primary"
                  onClick={() => handleClose()}
                  className={classes.buttonDialogSave}
                >
                  Close
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function RequestDocs(props) {
  const classes = useStyles();
  const { onClose, open } = props;

  const { data } = useSelector((state) => state.visaForm.documentRequired);

  const [requiredList, setRequiredList] = useState(data);

  useEffect(async () => {
    if (open) {
      setRequiredList(
        data.map((item) => ({ ...item, checked: false, remark: "" }))
      );
      // setRequiredList(data)
    }
  }, [open]);

  const handleListItemClick = () => {
    if (!window.confirm("Do you want to request documents?")) {
      return;
    }
    const _requested = requiredList.filter((x) => x.checked);
    if (_requested.length !== 0) {
      requiredList
        .filter((x) => x.checked)
        .every((itemObject) => itemObject.remark !== "")
        ? onClose(requiredList.filter((x) => x.checked))
        : alert("กรุณากรอกหมายเหตุ");
    } else {
      alert("กรุณาเลือกรายการ");
    }

    // console.log(found);

    // onClose(requested);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>
        ขอข้อมูลเพิ่มเติม
      </DialogTitle>
      <DialogContent>
        <div className={classes.rowMenuPopOver}>
          <FormGroup>
            {requiredList?.map((row, index) => (
              <div
                className={classes.wrapRequestDoc}
                key={row.configDocumentRequiredID}
              >
                <FormControlLabel
                  style={{ marginBottom: 16, alignItems: "start" }}
                  control={
                    <Checkbox
                      style={{ padding: "0px 9px" }}
                      checked={row.checked}
                      onChange={(event) => {
                        const _list = requiredList.map((item, index2) =>
                          index === index2
                            ? { ...item, checked: event.target.checked }
                            : item
                        );
                        setRequiredList(_list);
                      }}
                    />
                  }
                  label={row.documentName}
                />

                {row.checked && (
                  <TextField
                    placeholder="ระบุหมายเหตุ"
                    variant="outlined"
                    className={classes.textField}
                    name={row.configDocumentRequiredID}
                    value={row.remark}
                    onChange={(event) => {
                      const _list = requiredList.map((item, index2) =>
                        index === index2
                          ? { ...item, remark: event.target.value }
                          : item
                      );
                      setRequiredList(_list);
                    }}
                  />
                )}
              </div>
            ))}
          </FormGroup>

          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button
                  variant="outlined"
                  size="medium"
                  color="primary"
                  onClick={() => handleClose()}
                  className={classes.buttonDialogSave}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  size="medium"
                  color="primary"
                  onClick={() => handleListItemClick()}
                  className={classes.buttonDialogSave}
                >
                  Submit
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function ReturnRemarkDialog(props) {
  const classes = useStyles();
  const { onClose, open, onConfirm, } =
    props;

  const handleClose = () => {
    onClose();
  };

  const validationSchema = yup.object({
    draftRemark: yup.string()
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      draftRemark: "",
    },
    onSubmit: async (values) => {
      onConfirm(values.draftRemark);
      onClose();
    },
  });

  useEffect(async () => {
    if (open) {
      formik.resetForm();
    }
  }, [open]);

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>
        Remark
      </DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit} id="emp-form">
          <div>
            <Grid container>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <TextField
                    variant="outlined"
                    name={`draftRemark`}
                    placeholder="Your can add more detail for remark to user."
                    value={formik.values.reason_txt}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError(`draftRemark`, formik)}
                    helperText={getErrorMessage(`draftRemark`, formik)}
                    className={classes.textDialog}
                    multiline
                    rows={5}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button
                  variant="outlined"
                  size="medium"
                  type="button"
                  color="primary"
                  onClick={() => handleClose()}
                  className={classes.buttonDialogSave}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="medium"
                  type="submit"
                  color="primary"
                  className={classes.buttonDialogSave}
                >
                  Confirm
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
}

const StyleCheckbox = withStyles((theme) => ({
  root: {
    borderRadius: 6,
    color: "#8898aa",
    "&$checked": {
      color: theme.palette.success.main,
    },
  },
  checked: {},
}))(Checkbox);
